import { Component, Inject } from '@angular/core';

import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'seds-snackbar',
    templateUrl: './seds-snackbar.component.html',
    styleUrls: ['./seds-snackbar.component.scss'],
    standalone: false
})
export class SedsSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackBarRef: MatSnackBarRef<SedsSnackbarComponent>
  ) {}
}
